import React from 'react';

import {
  Text,
  Flex,
} from 'web-styled';

import noInvoices from 'web-assets/images/no_transactions.png';

const NoInvoices = () => (
  <Flex
    fillSpace
    column
    align="center"
    spacing={20}
    margin="20px 0 0 0"
  >
    <img src={noInvoices} alt="" />
    <Text
      align="center"
      color="#c0c0c0"
    >
      You don&#39;t have
      <br />
      any invoices
    </Text>
  </Flex>
);

export default NoInvoices;
